import { render } from "./Zi.vue?vue&type=template&id=2ba0e518&scoped=true"
import script from "./Zi.vue?vue&type=script&lang=js"
export * from "./Zi.vue?vue&type=script&lang=js"

import "./Zi.vue?vue&type=style&index=0&id=2ba0e518&scoped=scoped&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba0e518"]])

export default __exports__